import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M21.75 6.757a4.5 4.5 0 0 1-4.884 4.484c-1.076-.091-2.264.071-2.95.904L6.764 20.83a2.548 2.548 0 1 1-3.586-3.587l8.684-7.15c.833-.687.995-1.876.904-2.951a4.5 4.5 0 0 1 6.336-4.486L15.826 5.93a3 3 0 0 0 2.25 2.25l3.276-3.276c.256.565.398 1.192.398 1.852"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M4.867 19.132h.008v.007h-.008z"
    }, null, -1)
  ])))
}
export default { render: render }